import type { TypographyProps } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import type { ExtendedAudioItem } from '../../sources';
import { PlayerTrackInfo } from './player-track-info';
import { PodcastTrackInfo } from './podcast-track-info';
import { RadioTrackInfo } from './radio-track-info';

export interface TrackInfoContentProps {
  titleTextStyle: TypographyProps['textStyle'];
  authorTextStyle: TypographyProps['textStyle'];
  disableTicker: boolean;
  isVisible: boolean;
  wrapTitle?: boolean;
  track?: ExtendedAudioItem;
}

export function TrackInfoContent({
  isVisible,
  ...forwardingProps
}: TrackInfoContentProps) {
  const { sourceType } = useSettings();

  if (sourceType === 'rss') {
    return <PodcastTrackInfo {...forwardingProps} />;
  }

  if (sourceType === 'radio') {
    return <RadioTrackInfo {...forwardingProps} isVisible={isVisible} />;
  }

  return <PlayerTrackInfo {...forwardingProps} />;
}
